<template>
  <aside class="app-sidebar" :class="computedClass" :style="computedStyle">
    <ul class="app-sidebar__menu">
      <template v-for="(item, key) in items">
        <app-sidebar-link-group
          :key="key"
          :minimized="minimized"
          :icon="item.meta && item.meta.iconClass"
          v-if="item.children"
          :title="$t(item.displayName)"
          :children="item.children"
          :active-by-default="hasActiveByDefault(item)"
        >
          <app-sidebar-link
            v-for="(subMenuItem, key) in item.children"
            :key="key"
            :to="{ name: subMenuItem.name }"
            :title="$t(subMenuItem.displayName)"
            @click.native="handleRouteClick"
          />
        </app-sidebar-link-group>
        <template v-else>
         
          <li
            v-if="item.meta && item.meta.downloadUrl"
            :key="key"
            class="app-sidebar__download-btn"
            @click="downloadFile(item.meta.downloadUrl)"
          >
            <i :class="item.meta.iconClass"></i>
            <span v-if="!minimized">{{ $t(item.displayName) }}</span>
          </li>

          
          <app-sidebar-link
            v-else
            :key="key"
            :minimized="minimized"
            :active-by-default="item.name === $route.name"
            :icon="item.meta && item.meta.iconClass"
            :to="{ name: item.name }"
            :title="$t(item.displayName)"
            @click.native="handleRouteClick"
          />
        </template>
      </template>
    </ul>
  </aside>
</template>

<script>
import { navigationRoutes } from "./NavigationRoutes";
import AppSidebarLink from "./components/AppSidebarLink";
import AppSidebarLinkGroup from "./components/AppSidebarLinkGroup";
import { ColorThemeMixin } from "../../../services/vuestic-ui";

export default {
  name: "app-sidebar",

  inject: ["contextConfig"],
  components: {
    AppSidebarLink,
    AppSidebarLinkGroup,
  },
  mixins: [ColorThemeMixin],
  props: {
    minimized: {
      type: Boolean,
      required: true,
    },
    color: {
      type: String,
      default: "secondary",
    },
  },
  data() {
    return {
      items: navigationRoutes.routes,
    };
  },
  computed: {
    computedClass() {
      return {
        "app-sidebar--minimized": this.minimized,
      };
    },
    computedStyle() {
      return {
        backgroundColor: this.contextConfig.invertedColor
          ? "white"
          : this.colorComputed,
      };
    },
  },
  methods: {
    hasActiveByDefault(item) {
      return item.children.some((child) => child.name === this.$route.name);
    },
  },
  //   methods: {
  //   hasActiveByDefault (item) {
  //     return item.children && item.children.some(child => child.name === this.$route.name)
  //   },

  //   downloadFile (url) {

  //     const link = document.createElement('a')
  //     link.href = url
  //     link.setAttribute('download', '')
  //     document.body.appendChild(link)
  //     link.click()
  //     document.body.removeChild(link)
  //   },
  // },
  // Add this inside <script>
  methods: {
    hasActiveByDefault(item) {
      return (
        item.children &&
        item.children.some((child) => child.name === this.$route.name)
      );
    },

    downloadFile(url) {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
     
      this.$emit("close-sidebar");
    },

    handleRouteClick() {
      
      this.$emit("close-sidebar");
    },
  },
};
</script>

<style lang="scss">
.app-sidebar {
  overflow: auto;
  display: flex;
  max-height: 100%;
  flex: 0 0 16rem;

  @include media-breakpoint-down(sm) {
    flex: 0 0 100%;
  }

  &--minimized {
    flex: 0 0 3.25rem;
  }

  &__menu {
    margin-bottom: 0;
    padding-top: 2.5625rem;
    padding-bottom: 2.5rem;
    list-style: none;
    padding-left: 0;
    width: 100%;
  }
}
.app-sidebar__download-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.5rem 1rem;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  background-color: #2c7be5; /* Primary blue */
  color: #fff;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  i {
    margin-right: 0.5rem;
  }

  &:hover {
    background-color: #1a68d1;
  }

  &:active {
    background-color: #155bb5;
  }
}
</style>
